import { Component, Shark, Utils } from "shark-mvc";
import $ from "jquery";
import moment from "moment";

import templateContent from "Templates/components/activity-report.html";

import exportCSVComponent from "../../components/exportCSV/exportCSVComponent";
import { exportPDFComponent } from "../../_shark_components/exportPDF/exportPDFComponent";
import printButtonComponent from "../../_shark_components/printButton/printButtonComponent";

class ActivityReportComponent extends Component {
	constructor () {
		super("activityReportComponent");
		this.addTemplate("", templateContent);
	}

	activityReportCloseBtn_clickHandler () {
		this.close();
	}

	close () {
		exportCSVComponent.set({
			dataSourceType: null,
			htmlTableSelector: null,
		});

		$("#activityReportModal").modal("hide");
	}

	init () {
		this.addComponents([exportCSVComponent, exportPDFComponent, printButtonComponent]);
	
		this.set({
			__reportType: ""
		});
	}
	
	showReportBtn_clickHandler () {
		exportPDFComponent.set("documentToExport", null);

		//Dave: tutta questa gestione va migliorata
		exportCSVComponent.set({
			dataSourceType: "htmlTable",
			htmlTableSelector: "#totals table",
			savedFileBaseName: `Tabella riassuntiva ${this.get("__reportType")} per agente e per provincia`,
		});	

		$("#activityReportModal").modal("show");
	}







		
	extractReport (itemList) {
		console.time("activityReportComponent.extractReport");
		const completeReport = this.extractSingleReport(itemList);

		const agentList = new Set();
		itemList.forEach((item) => {
			const agent = item.__reportData ? item.__reportData.agentName : (item.__prospectAssignedAgentName || item.__agentFullName);
			agentList.add(agent);
		});

		completeReport.agents = Array.from(agentList).map(agent => {
			const agentReport = this.extractSingleReport(itemList, agent);
			agentReport.agentName = agent;
			agentReport.guid = Shark.__generateGUID();

			return agentReport;
		});

		console.log({agentList, completeReport});
		console.timeEnd("activityReportComponent.extractReport");

		return completeReport;
	}

	extractSingleReport (itemList, agent = "") {
		//Dave.ToDo: Devo gestire l'informazione sul "__render"
		const singleReport = {
			activityStatus: {},
			agent: {},
			agents: [],
			contactSource: {},
			outcome: {},
			province: {},
			quotationStatus: {},
			sector: {},
			time: {},
			total: 0,
			visitStatus: {},
			__showActivityStatusData: itemList.length > 0 && itemList[0].__modelName === "Client",
			__showContactSourceData: ["quotationListView", "siteInfoSheetListView"].indexOf(Shark.activePage.id) === -1,
			__showOutcomeData: itemList.length > 0 && itemList[0].__modelName === "Visit",
			__showQuotationStatusData: itemList.length > 0 && (itemList[0].__modelName === "Quotation"),
			__showSiteInfoSheetQuotationStatusData: itemList.length > 0 && (itemList[0].__modelName === "SiteInfoSheet"),
			__showVisitStatusData: itemList.length > 0 && (itemList[0].__modelName === "Visit"),
		};

		const clientActivityStatusList = Shark.get("clientActivityStatusList");
		clientActivityStatusList.forEach(item => singleReport.activityStatus[item.id] = { total: 0 });
		singleReport.activityStatus[0] = { total: 0 };

		const contactSourceList = Shark.get("contactSourceList");
		contactSourceList.forEach(item => singleReport.contactSource[item.id] = { total: 0 });
		singleReport.contactSource["Non impostata"] = { total: 0 };

		const sectorList = Shark.get("sectorList");
		sectorList.forEach(item => singleReport.sector[item] = { total: 0 });
		singleReport.sector["Non impostato"] = { total: 0 };

		const siteInfoSheetQuotationStatusList = Shark.get("siteInfoSheetQuotationStatusList");
		const quotationStatusList = Shark.get("quotationStatusList");
		if (singleReport.__showSiteInfoSheetQuotationStatusData) {
			siteInfoSheetQuotationStatusList.forEach(item => singleReport.quotationStatus[item.id] = { total: 0 });
			singleReport.quotationStatus[0] = { total: 0 };
		}
		else if (singleReport.__showQuotationStatusData) {
			quotationStatusList.forEach(item => singleReport.quotationStatus[item.id] = { total: 0 });
			singleReport.quotationStatus[0] = { total: 0 };
		}

		const visitOutcomeList = Shark.get("visitOutcomeList");
		visitOutcomeList.forEach(item => singleReport.outcome[item.id] = { total: 0 });
		singleReport.outcome[0] = { total: 0 };
		
		const visitStatusList = Shark.get("visitStatusList");
		visitStatusList.forEach(item => singleReport.visitStatus[item.id] = { total: 0 });
		singleReport.visitStatus[0] = { total: 0 };

		const provinceSet = new Set();
		let provinceList = [];

		let maxDate = "";
		let minDate = moment().format("YYYY-MM-DD");

		itemList.forEach((item) => {
			let itemAgent = item.__reportData ? item.__reportData.agentName : (item.__prospectAssignedAgentName || item.__agentFullName);

			if (agent === "" || itemAgent === agent) {
				if (item.__render) {
					let province;
					if (item.__reportData) {
						province = item.__reportData.province;
					}
					else {
						province = item.province;
					}

					provinceSet.add(province);
				}
			}
		});

		provinceList = Array.from(provinceSet);
		provinceList.sort();
		if (provinceList[0] === "") {
			provinceList[0] = "N/D";
		}

		provinceList.forEach(province => {
			singleReport.province[province] = 0;
		});

		itemList.forEach((item) => {
			let itemAgent = item.__reportData ? item.__reportData.agentName : (item.__prospectAssignedAgentName || item.__agentFullName);

			if (agent === "" || itemAgent === agent) {
				if (item.__render) {
					let province;
					if (item.__reportData) {
						province = item.__reportData.province;
					}
					else {
						province = item.province;
					}

					if (province === "") {
						province = "N/D";
					}
				
					if (item.hasOwnProperty("__referenceDate")) {
						maxDate = (item.__referenceDate.trim() !== "" && item.__referenceDate > maxDate) ? item.__referenceDate : maxDate;
						minDate = (item.__referenceDate.trim() !== "" && item.__referenceDate < minDate) ? item.__referenceDate : minDate;
					}
					else if (item.hasOwnProperty("__agentAssignmentDate")) {
						maxDate = (item.__agentAssignmentDate.trim() !== "" && item.__agentAssignmentDate > maxDate) ? item.__agentAssignmentDate : maxDate;
						minDate = (item.__agentAssignmentDate.trim() !== "" && item.__agentAssignmentDate < minDate) ? item.__agentAssignmentDate : minDate;
					}

					singleReport.province[province]++;
					singleReport.total++;

					//Dave.ToDo: Aggiungere la gestione delle provincie dell'Agente + Extra da dati
					const contactSource = item.contactSource || "Non impostata";
					if (singleReport.contactSource[contactSource]) {
						singleReport.contactSource[contactSource].total++;
						if (singleReport.contactSource[contactSource][province]) {
							singleReport.contactSource[contactSource][province]++;
						}
						else {
							singleReport.contactSource[contactSource][province] = 1;
						}
					}
					else {
						// console.warn("BBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBB");
					}

					const outcome = item.outcome || "Non impostato";
					if (singleReport.outcome[outcome]) {
						singleReport.outcome[outcome].total++;
						if (singleReport.outcome[outcome][province]) {
							singleReport.outcome[outcome][province]++;
						}
						else {
							singleReport.outcome[outcome][province] = 1;
						}
					}
					else {
						// console.warn(outcome, "CCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCC");
					}

		//			const sector = item.prospectSector || item.sector || "Non impostato";
					let sector = item.__reportData ? item.__reportData.sector : null;
					sector = sector || item.prospectSector || item.sector || "Non impostato";
					if (singleReport.sector[sector]) {
						singleReport.sector[sector].total++;
						if (singleReport.sector[sector][province]) {
							singleReport.sector[sector][province]++;
						}
						else {
							singleReport.sector[sector][province] = 1;
						}
					}
					else {
						// console.warn("AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA");
					}

					if (singleReport.__showVisitStatusData) {
						let visitStatus = item.__reportData.statusId;
						if (singleReport.visitStatus[visitStatus]) {
							singleReport.visitStatus[visitStatus].total++;
							if (singleReport.visitStatus[visitStatus][province]) {
								singleReport.visitStatus[visitStatus][province]++;
							}
							else {
								singleReport.visitStatus[visitStatus][province] = 1;
							}
						}
						else {
							//console.warn("AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA");
						}
					}

					const activityStatusId = item.extraData.activityStatusId || 0;//"Non impostato";
					if (singleReport.activityStatus[activityStatusId]) {
						singleReport.activityStatus[activityStatusId].total++;
						if (singleReport.activityStatus[activityStatusId][province]) {
							singleReport.activityStatus[activityStatusId][province]++;
						}
						else {
							singleReport.activityStatus[activityStatusId][province] = 1;
						}
					}
					else {
						//console.warn("AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA");
					}

					if (singleReport.__showSiteInfoSheetQuotationStatusData) {
						const quotationStatusId = item.__reportData ? item.__reportData.quotationStatus : item.extraData.quotation.status || 0;//"Non impostato";
						if (singleReport.quotationStatus[quotationStatusId]) {
							singleReport.quotationStatus[quotationStatusId].total++;
							if (singleReport.quotationStatus[quotationStatusId][province]) {
								singleReport.quotationStatus[quotationStatusId][province]++;
							}
							else {
								singleReport.quotationStatus[quotationStatusId][province] = 1;
							}
						}
						else {
							//console.warn("AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA");
						}
					}
					else if (singleReport.__showQuotationStatusData) {
						const quotationStatusId = item.__reportData.status;
						if (singleReport.quotationStatus[quotationStatusId]) {
							singleReport.quotationStatus[quotationStatusId].total++;
							if (singleReport.quotationStatus[quotationStatusId][province]) {
								singleReport.quotationStatus[quotationStatusId][province]++;
							}
							else {
								singleReport.quotationStatus[quotationStatusId][province] = 1;
							}
						}
						else {
							//console.warn("AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA");
						}
					}
				}
			}
		}, this);

		singleReport.sectorTable = [];
		singleReport.sectorTable.push(["Settore Merceologico", "N. " + this.get("__reportType"), ...provinceList]);

		for (let currProp in singleReport.sector) {
			let newRow = provinceList;

			newRow = newRow.map(province => {
				if (singleReport.sector[currProp][province]) {
					return singleReport.sector[currProp][province];
				}
				else {
					return "";
				}
			});
			const currPropTotal = singleReport.sector[currProp].total !== 0 ? singleReport.sector[currProp].total : "";
			singleReport.sectorTable.push([currProp, currPropTotal, ...newRow]);
		}
		// console.table(singleReport.province);

		const contactSourceMap = Shark.get("contactSourceMap");
		singleReport.contactSourceTable = [];
		singleReport.contactSourceTable.push(["Modalità contatto", "N. " + this.get("__reportType"), ...provinceList]);
		for (let currProp in singleReport.contactSource) {
			let newRow = provinceList;

			newRow = newRow.map(province => {
				if (singleReport.contactSource[currProp][province]) {
					return singleReport.contactSource[currProp][province];
				}
				else {
					return "";
				}
			});
			const currPropTotal = singleReport.contactSource[currProp].total !== 0 ? singleReport.contactSource[currProp].total : "";
			singleReport.contactSourceTable.push([contactSourceMap[currProp] || currProp, currPropTotal, ...newRow]);
		}
		// console.table(singleReport.contactSourceTable);

		const visitOutcomeMap = Shark.get("visitOutcomeMap");
		singleReport.outcomeTable = [];
		singleReport.outcomeTable.push(["Esito del contatto", "N. " + this.get("__reportType"), ...provinceList]);
		for (let currProp in singleReport.outcome) {
			let newRow = provinceList;

			newRow = newRow.map(province => {
				if (singleReport.outcome[currProp][province]) {
					return singleReport.outcome[currProp][province];
				}
				else {
					return "";
				}
			});
			const currPropTotal = singleReport.outcome[currProp].total !== 0 ? singleReport.outcome[currProp].total : "";
			singleReport.outcomeTable.push([visitOutcomeMap[currProp] || currProp, currPropTotal, ...newRow]);
		}
		// console.table(singleReport.outcomeTable);

		const visitStatusMap = Shark.get("visitStatusMap");
		singleReport.visitStatusTable = [];
		singleReport.visitStatusTable.push(["Status", "N. " + this.get("__reportType"), ...provinceList]);
		for (let currProp in singleReport.visitStatus) {
			let newRow = provinceList;

			newRow = newRow.map(province => {
				if (singleReport.visitStatus[currProp][province]) {
					return singleReport.visitStatus[currProp][province];
				}
				else {
					return "";
				}
			});
			const currPropTotal = singleReport.visitStatus[currProp].total !== 0 ? singleReport.visitStatus[currProp].total : "";
			singleReport.visitStatusTable.push([visitStatusMap[currProp] || currProp, currPropTotal, ...newRow]);
		}
		// console.table(singleReport.outcomeTable);

		const clientActivityStatusMap = Shark.get("clientActivityStatusMap");
		singleReport.activityStatusTable = [];
		singleReport.activityStatusTable.push(["Stato", "N. " + this.get("__reportType"), ...provinceList]);
		for (let currProp in singleReport.activityStatus) {
			let newRow = provinceList;

			newRow = newRow.map(province => {
				if (singleReport.activityStatus[currProp][province]) {
					return singleReport.activityStatus[currProp][province];
				}
				else {
					return "";
				}
			});
			const currPropTotal = singleReport.activityStatus[currProp].total !== 0 ? singleReport.activityStatus[currProp].total : "";
			singleReport.activityStatusTable.push([clientActivityStatusMap[currProp] || currProp, currPropTotal, ...newRow]);
		}
		// console.table(singleReport.activityStatus);


		if (singleReport.__showSiteInfoSheetQuotationStatusData) {
			const siteInfoSheetQuotationStatusMap = Shark.get("siteInfoSheetQuotationStatusMap");
			singleReport.quotationStatusTable = [];
			singleReport.quotationStatusTable.push(["Stato", "N. " + this.get("__reportType"), ...provinceList]);
			for (let currProp in singleReport.quotationStatus) {
				let newRow = provinceList;

				newRow = newRow.map(province => {
					if (singleReport.quotationStatus[currProp][province]) {
						return singleReport.quotationStatus[currProp][province];
					}
					else {
						return "";
					}
				});
				const currPropTotal = singleReport.quotationStatus[currProp].total !== 0 ? singleReport.quotationStatus[currProp].total : "";
				singleReport.quotationStatusTable.push([siteInfoSheetQuotationStatusMap[currProp] || currProp, currPropTotal, ...newRow]);
			}
		}
		else if (singleReport.__showQuotationStatusData) {
			const quotationStatusMap = Shark.get("quotationStatusMap");
			singleReport.quotationStatusTable = [];
			singleReport.quotationStatusTable.push(["Stato", "N. " + this.get("__reportType"), ...provinceList]);
			for (let currProp in singleReport.quotationStatus) {
				let newRow = provinceList;

				newRow = newRow.map(province => {
					if (singleReport.quotationStatus[currProp][province]) {
						return singleReport.quotationStatus[currProp][province];
					}
					else {
						return "";
					}
				});
				const currPropTotal = singleReport.quotationStatus[currProp].total !== 0 ? singleReport.quotationStatus[currProp].total : "";
				singleReport.quotationStatusTable.push([quotationStatusMap[currProp] || currProp, currPropTotal, ...newRow]);
			}
		}

		const dateRangeFilter = Shark.get("dateRangeFilter");

		singleReport.provinceLabels = Object.keys(singleReport.province);
		singleReport.provinceValues = Object.values(singleReport.province);

		singleReport.provinceLabels.unshift("N. " + this.get("__reportType"));
		singleReport.provinceLabels.unshift("Periodo di riferimento");

		singleReport.provinceValues.unshift(singleReport.total);
		if (dateRangeFilter && !dateRangeFilter.ignoreDateRange) {
			maxDate = dateRangeFilter.__to;
			minDate = dateRangeFilter.__from;
		}
		singleReport.provinceValues.unshift(`dal ${moment(minDate).format("DD/MM/YYYY")} al ${moment(maxDate).format("DD/MM/YYYY")}`);

		console.log({ itemList, singleReport });

		return singleReport;
	}

}

const activityReportComponent = new ActivityReportComponent();

Shark.registerComponent(activityReportComponent);

export { activityReportComponent };
